export default {
  id: null,
  name: '',
  messagesTotal: 0,
  messages: [],
}
